angular.module('rjmNg.directives').directive "setOrderBy", [
  "utils"
  (utils) ->
    restrict: "E"
    templateUrl: "directive.orderBy.html"
    replace: true
    scope:
      selectedMetrics: "="
      update: "&"
      popover: "="
    controllerAs: "view"
    bindToController: true
    controller: [
      "app"
      "rjqlStringConstants"
      (
        app
        rjqlStringConstants
      ) ->
        view = @
        view.metrics = []

        PERCENT_REGEX = /^\d+$|^\d\d?%$|^100%$/
        NUMBER_REGEX = /^\d+$|^All$/i
        ALLOW_PERCENT_LIMITS = not app.hasFeatureFlag('RJQL_SERVICE_CLIENT')
        if ALLOW_PERCENT_LIMITS
          LIMIT_DEFAULT = "100%"
          LIMIT_REGEX = PERCENT_REGEX
          view.ERROR_MESSAGE = "Data limit error: Limit should be a number or a %."
        else
          LIMIT_DEFAULT = "ALL"
          LIMIT_REGEX = NUMBER_REGEX
          view.ERROR_MESSAGE = "Data limit error: Limit should be a number or ALL."

        # Applies any changes to the order by or limit to the selected metrics
        # and runs the update function of the report builder
        view.setLimit = () ->
          for metric, index in view.selectedMetrics
            if metric.type is 'metric'
              metric.order =
                limit:
                  take: if view.translatedMetrics[index].order.limit.take.toUpperCase() is "ALL" then "100%" else view.translatedMetrics[index].order.limit.take
                fields: [[
                  view.translatedMetrics[index].order.fields[0][0],
                  view.translatedMetrics[index].order.fields[0][1]
                ]]
          view.update()
          view.popover.hide()

        view.cancel = () ->
          view.popover.hide()

        _getDefaultOrder = (metric) ->
          limit:
            take: LIMIT_DEFAULT
          fields: [[":value",":desc"]]
          fieldOptions: _generateFieldOptions(metric)
          dirOptions: _generateDirOptions(metric)

        # Translate a copied metric for use in this directive
        _translateMetric = (metric) ->
          translatedMetric =
            type: metric.type
            alias: if metric.alias? then metric.alias
            order: if metric.order?.limit? then _translateOrder(metric) else _getDefaultOrder(metric)
          return translatedMetric

        # Adds a list of options to pick from to the order object
        _translateOrder = (metric) ->
          if metric.type isnt 'metric'
            return {}

          translatedOrder =
            limit:
              take: if metric.order.limit.take is "100%" and not ALLOW_PERCENT_LIMITS then "ALL" else metric.order.limit.take
            fields: [ [metric.order.fields[0][0], metric.order.fields[0][1]] ]
            fieldOptions: _generateFieldOptions(metric)
            dirOptions: _generateDirOptions(metric)

          return translatedOrder

        # Generates a list of possible options we can pick from this metric
        _generateFieldOptions = (metric) ->
          if metric.type isnt 'metric'
            return {}

          options = [
            id: ':value'
            alias: metric.alias
          ]
          options.push {id: dim.column_id, alias: "#{dim.name}", datatype: dim.datatype} for dim in metric.dimensions when dim.column_id isnt rjqlStringConstants.RJQL_UNBOUND
          return options

        # Should we flip the direction options?
        _getFlip = (metric) ->
          unless metric.order?
            return false
          else
            if metric.order.fields[0][0] isnt ':value'
              if metric.dimensions?
                dimensionDatatype = _.findWhere(metric.dimensions, {column_id: metric.order.fields[0][0]}).datatype
              else
                dimensionDatatype = _.findWhere(metric.order.fieldOptions, {id: metric.order.fields[0][0]}).datatype
              return dimensionDatatype.startsWith('VARCHAR') or dimensionDatatype.startsWith('CHAR') or dimensionDatatype.startsWith('BLOB') or dimensionDatatype.startsWith('TEXT')
            else
              return false

        # Generates a list of options.  The definition of Top and Bottom changes
        # whether we are talking about metric values or dimension names
        _generateDirOptions = (metric) ->
          oldOptions = metric.order?.dirOptions
          oldOptions ?= null

          if _getFlip(metric)
            newOptions = [
              {id: ':asc', alias: 'Top'},
              {id: ':desc', alias: 'Bottom'}
            ]
          else
            newOptions = [
              {id: ':desc', alias: 'Top'},
              {id: ':asc', alias: 'Bottom'}
            ]

          # If we're changing the options, we need to change our selection, too
          if oldOptions? and not angular.equals(oldOptions, newOptions)
            _toggleSelectedDirection(metric)

          return newOptions

        _toggleSelectedDirection = (metric) ->
          if metric.order.fields[0][1] is ':asc'
            metric.order.fields[0][1] = ':desc'
          else
            metric.order.fields[0][1] = ':asc'

        # Occasionally we need to update the options in case we need to flip them
        view.updateDirectionOptions = (metric) ->
          metric.order.dirOptions = _generateDirOptions(metric)

        # Get metrics ready for this directive
        view.translateMetrics = () ->
          view.translatedMetrics = view.metrics.map((metric) -> _translateMetric(metric))

        view.chackIfReadyToSave = () ->
          for metric in view.translatedMetrics
            metric.valid = LIMIT_REGEX.test(metric.order.limit.take)
          view.isReadyToSave = not (false in view.translatedMetrics.map((metric) -> metric.valid))

        view
    ]
    link: (scope, elem, attrs, view) ->

      scope.$watch(
        'view.selectedMetrics'
        (newSelectedMetrics, oldSelectedMetrics) ->
          if newSelectedMetrics.length > 0
            # Make a local copy of the metrics
            view.metrics = utils.copy(newSelectedMetrics)
            # Translate the directions so we see Top/Bottom instead of :desc/:asc
            view.translateMetrics()
            view.chackIfReadyToSave()
        true
      )
]
